import type {TaskBlendedResponse} from 'src/api/ProactApiClient';
import {actionApiClient} from 'src/api/ProactApiClientInstances';
import {actionQueryFn} from 'src/app/tasks/offline/reads';
import {emptySplitApi} from '../api';

export const actionApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getAction: builder.query<TaskBlendedResponse, number>({
      queryFn: actionQueryFn(id => actionApiClient.get(id)),
      providesTags: ['TaskAssignments'],
    }),
  }),
});

export const {useGetActionQuery} = actionApi;
